export default __webpack_public_path__ + "static/media/Links-BlankIMGs-02.c96f409a.svg";